import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// 1. Activar el modo producción si la configuración lo indica
if (environment.production) {
  enableProdMode();
}

// 2. Gestión de logs según entorno
const isLocal =
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1';

// 3. Override de emergencia para debugging en servidores remotos (DEV/PRE/PROD)
// Para activar: localStorage.setItem('DEBUG_MODE', 'true')
// Para desactivar: localStorage.removeItem('DEBUG_MODE')
const debugMode = localStorage.getItem('DEBUG_MODE') === 'true';

// Indicador visual del entorno
if (!isLocal) {
  const isDev = window.location.hostname.includes('dev.');
  const isPre = window.location.hostname.includes('pre.');
  const env = isDev ? 'DEV' : isPre ? 'PRE' : 'PROD';
  const color = isDev ? '#FFA500' : isPre ? '#FF6B6B' : '#FF0000';
  
  console.log(
    `%c🌍 Entorno: ${env}`,
    `color: ${color}; font-size: 16px; font-weight: bold;`
  );
  
  if (debugMode) {
    console.warn(`🔧 DEBUG_MODE activado en ${env}`);
    console.warn('Para desactivar: localStorage.removeItem("DEBUG_MODE")');
  }
}

// Ocultar logs en servidores remotos (excepto si DEBUG_MODE está activo)
if (!isLocal && !debugMode) {
  window.console.log = () => {};
  window.console.info = () => {};
  window.console.debug = () => {};
  // Siempre mantener console.error y console.warn para diagnóstico
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, {
    ngZoneEventCoalescing: true,
  })
  .catch((err) => console.error(err));
